import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
var fileTypeMapping = [
    {
        extensions: ['pdf'],
        mimeTypes: ['application/pdf'],
        icon: _jsx(PictureAsPdfOutlinedIcon, { color: "error" }),
    },
    {
        extensions: ['png', 'jpg', 'jpeg', 'gif'],
        mimeTypes: ['image/png', 'image/jpeg', 'image/gif'],
        icon: _jsx(ImageOutlinedIcon, { color: "action" }),
    },
    {
        extensions: ['txt'],
        mimeTypes: ['text/plain'],
        icon: _jsx(DescriptionOutlinedIcon, { color: "action" }),
    },
    {
        extensions: ['doc', 'docx'],
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ],
        icon: _jsx(InsertDriveFileOutlinedIcon, { color: "primary" }),
    },
    {
        extensions: ['xls', 'xlsx'],
        mimeTypes: [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ],
        icon: _jsx(InsertDriveFileOutlinedIcon, { color: "success" }),
    },
];
var defaultIcon = _jsx(InsertDriveFileOutlinedIcon, { color: "disabled" });
var getFileExtension = function (name) { var _a; return ((_a = name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || ''; };
export var AttachmentIcon = function (_a) {
    var fileName = _a.fileName, mimeType = _a.mimeType;
    var icon = useMemo(function () {
        var extension = fileName ? getFileExtension(fileName) : null;
        var match = fileTypeMapping.find(function (type) {
            return (extension && type.extensions.includes(extension)) ||
                (mimeType && type.mimeTypes.includes(mimeType));
        });
        return match ? match.icon : defaultIcon;
    }, [fileName, mimeType]);
    return icon;
};
